export default {
  talkToSis: {
    title: '¡Contáctenos!',
    description:
      '¿Desea conversar con uno de nuestros especialistas? Entonces contáctenos. Tenemos un equipo cualificado para atender sus necesidades.',
    buttonText: 'Hablar con un especialista SIS',
  },
}
